var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.084,
    height: 70.084,
    viewBox: "0 0 70.084 70.084",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1788",
    "data-name": "Group 1788",
    transform: "translate(-11839.898 -8758.742)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_54",
    "data-name": "Subtraction 54",
    d: "M35.076,70.082A35.02,35.02,0,0,1,4.7,52.558,35.03,35.03,0,0,1,35.011,0,35.216,35.216,0,0,1,52.54,4.681L35.224,34.367l34.852-.155a35.03,35.03,0,0,1-35,35.87Z",
    transform: "translate(11909.98 8758.742) rotate(90)",
    fill: "#c2c4c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_55",
    "data-name": "Subtraction 55",
    d: "M35.076,70.082A35.02,35.02,0,0,1,4.7,52.558,35.03,35.03,0,0,1,35.011,0,35.216,35.216,0,0,1,52.54,4.681L35.224,34.367l34.852-.155a35.03,35.03,0,0,1-35,35.87Z",
    transform: "translate(11839.898 8758.743)",
    fill: "#575757"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pieChart.7c5080626a41cc50604a19873c89df73.svg";
export { ForwardRef as ReactComponent };